<template>
  <v-dialog max-width="40%" v-model="dialog">
    <template #activator="{ on }">
      <v-btn icon small v-on="on">
        <v-icon color="green" small>fas fa-check-double</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>Complete This Work Order</v-card-title>
      <v-card-text>
        This will put the workorder in a "completed" state.
        This can be undone by adding the workorder back to the que.
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="close" text>Close</v-btn>
        <v-btn @click="complete" text color="green" :loading="loading">Submit</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ToolProcess from "../../models/ToolProcess";
export default {
  name: "ToolProcessCompleteButton",
  props: {
    processid: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      dialog: false,
      loading: false
    }
  },
  methods: {
    complete() {
      this.loading = true;
      ToolProcess
        .$patch(this.processid, { in_process: false })
        .then(() => {
          this.loading = false;
          this.close();
        })
    },
    close() {
      this.dialog = false
    }
  }
}
</script>
